<template>
  <div class="donation">
    <img src="https://ws4.sinaimg.cn/large/006tNc79ly1fnyqbykokqj30w00w0wh9.jpg">
  </div>
</template>
<script type="text/javascript">
export default {}
</script>

<style lang="stylus">
.donation
  position absolute
  height 100%
  width 100%
  top 0
  left 0
  display flex
  align-items center
  justify-content center

  img
    width 30%
</style>



// WEBPACK FOOTER //
// src/views/Donation.vue